<template>
  <BaseOfferPanel
    offer-type-icon="ca-icon"
    :offer-image-url="swayOffer.offer_image_url"
    :offer-summary="swayOffer.offer_summary"
    :offer-start-date="swayOffer.offer_start_date"
  >
    <template #offerPreview>
      <SwayOfferPreview :short-url-id="swayOffer.short_url_id" />
    </template>

    <template #offerControls>
      <SwayOfferControls :sway-offer="swayOffer" />
    </template>

    <template #formBase>
      <SwayOfferFormBase :sway-offer="swayOffer" />
    </template>
  </BaseOfferPanel>
</template>

<script>
import Vue from 'vue'

import BaseOfferPanel from '@/components/Offers/OfferPanels/BaseOfferPanel'
import SwayOfferPreview from '@/components/Offers/OfferForm/SwayOfferPreview'
import SwayOfferFormBase from '@/components/Offers/OfferForm/SwayOfferFormBase'
import SwayOfferControls from '@/components/Offers/OfferForm/SwayOfferControls'

export default Vue.extend({
  name: 'BaseSwayOfferPanel',

  components: {
    BaseOfferPanel,
    SwayOfferPreview,
    SwayOfferFormBase,
    SwayOfferControls,
  },

  props: {
    swayOffer: {
      type: Object,
      required: true,
    },
  },
})
</script>
